// new api demo
// sandbox
// export const BASE_URL = "https://kaaruj-backend.sandbox.devsstream.com/";

// export  const BASE_URL = "https://kaaruj.backend.clients.devsstream.com/"
// live
// export  const BASE_URL = "https://website-backend.kaaruj.cloud/";
// demourl
export const BASE_URL = "https://kaaruj-backend.sandbox.payinpos.com/";
